import React, { useEffect } from "react";
import { navigate, useLocation } from "@reach/router";
import { getRadioEntryPath } from "./entryIntentStorage";
import EntryFlowGate from "./EntryFlowGate";

export default function RadioEntryGuard({ children }) {
  const location = useLocation();
  const target = getRadioEntryPath();
  const redirect =
    !!target &&
    ["/", "/sonicboxes"].includes(location.pathname.replace(/\/$/, "") || "/");
  useEffect(() => {
    if (redirect) navigate(target, { replace: true });
  }, [redirect, target]);
  return redirect ? <EntryFlowGate /> : children;
}
